import { FieldArray } from 'formik';
import AddButton from "./UI/AddButton";
import Accordion from './UI/Accordion';
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import FieldGroupContainer from "./UI/FieldGroupContainer";

const newProdCompany = {
  name: "",
  address1: "",
  address2: "",
  city: "",
  stateProv: "",
  zipCode: ""
}

const ProdCompanyInput = ({companies, setField}) => {
  return(
    <FieldArray name="prodCompanies">
      {({ insert, remove, push}) => (
        <div>
          {companies.length > 0 &&
            companies.map((prodCompanies, index)=> (
              <Accordion
                key={index}
                title={prodCompanies.name}
                fieldSetter={(e) => setField(`prodCompanies[${index}].name`, e.target.value)}
                deleteMethod={() => remove(index)}
              >
                <FieldGroupContainer>
                  <FieldWithErrorDisplay
                    labelFor={`prodCompanies.${index}.address1`}
                    label="Address 1"
                    type="text"
                  />
                  <FieldWithErrorDisplay
                    labelFor={`prodCompanies.${index}.address2`}
                    label="Address 2"
                    type="text"
                  />
                  <FieldWithErrorDisplay
                    labelFor={`prodCompanies.${index}.city`}
                    label="City"
                    type="text"
                  />
                  <FieldWithErrorDisplay
                    labelFor={`prodCompanies.${index}.stateProv`}
                    label="State/Province"
                    type="text"
                  />
                  <FieldWithErrorDisplay
                    labelFor={`prodCompanies.${index}.zipCode`}
                    label="Zip Code"
                    type="text"
                  />
                </FieldGroupContainer>
              </Accordion>
            ))
          }
          <AddButton
            type="button"
            onClick={() => push({...newProdCompany, name: `Production Company ${companies.length + 1}`})}
          >
            Add Department
          </AddButton>
        </div>
      )}
    </FieldArray>
  )
}

export default ProdCompanyInput;
